import type { ReactNode } from 'react';

export function SectionLabel({ children, index }: { children: ReactNode; index?: string }): JSX.Element {
  return <div className="section-label"><span>{index ?? '—'}</span><span>{children}</span></div>;
}
